import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PageNotFoundComponent } from '@sondermind/features/page-not-found';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { PublicFooterComponent } from '@sondermind/features/app-footer';
import { SupportPhoneNumberCardComponent } from '@sondermind/features/support-phone-number-card';
import { BrowseTherapistsCard } from '@sondermind/features/browse-therapists-card';
import { ProviderCalendarComponent } from '@sondermind/features/public-facing/provider-calendar';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { NativeAppInterfaceModule } from '@sondermind/native-app-interface';
import { FindMyFitComponent } from '@sondermind/features/ai-connect-provider-directory';

import { ConnectCardComponent } from './components/connect-card/connect-card.component';
import { DirectoryComponent } from './components/directory/directory.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LandingPageHeaderComponent } from './components/landing-page-header/landing-page-header.component';
import { ProviderDetailsComponent } from './components/provider-details/provider-details.component';

@NgModule({
  declarations: [
    DirectoryComponent,
    LandingPageComponent,
  ],
  imports: [
    BrowseTherapistsCard,
    CommonModule,
    RouterModule,
    PageNotFoundComponent,
    IrisButtonModule,
    IrisCardModule,
    IrisIconButtonModule,
    IrisIconComponent,
    PublicFooterComponent,
    ConnectCardComponent,
    LandingPageHeaderComponent,
    ProviderDetailsComponent,
    ProviderCalendarComponent,
    PublicHeaderModule,
    SupportPhoneNumberCardComponent,
    NativeAppInterfaceModule,
    MatProgressSpinnerModule,
    FindMyFitComponent,
  ],
  exports: [
    PageNotFoundComponent,
    RouterModule,
    IrisButtonModule,
    ConnectCardComponent,
    DirectoryComponent,
    LandingPageComponent,
    LandingPageHeaderComponent,
    ProviderDetailsComponent,
  ],
})
export class ProviderProfilePageModule { }
